import store from "@/store";

export default async (to, from, next) => {
  await store.dispatch("setEditModel", {
    model: _.get(to, "params.model"),
    id: _.get(to, "params.id")
  });
  next();
};
